<template>
    <div class="main">
        <mHead :title="'精选案例'" :showSearch="true" :classType="'light'"></mHead>
        <div id="caseList" class="caseList">
            <template v-if="caseList.length > 0">
                <div class="item" v-for="item in caseList" :key="item.id" @click="toDetail(item.id)">
                    <img @load="loadImg" :src="item.imageUrl" alt="">
                    <div class="info">
                        <p class="name">{{item.caseName}}</p>
                        <p class="clear">
                            <span class="left">{{item.labels}}</span>
                            <span class="right">{{item.author}}</span>
                        </p>
                    </div>
                </div>
            </template>
            <p class="empty" v-else>
                暂无数据...
            </p>
        </div>
        <mBottom :classType="'light'"></mBottom>
    </div>
</template>

<script>
import mHead from '@/components/base/mobile/mHead.vue'
import mBottom from '@/components/base/mobile/mBottom.vue'
export default {
    name: 'case',
    components:{mHead,mBottom},
    data(){
        return {
            caseList: [],
            loadNum: 0
        }
    },
    mounted(){
        this.getList();
    },
    methods: {
        toDetail(id){
            this.$router.push('/detail/'+id)
        },
        getList(){
            this.$http.get(this.service.dev.api.recommendList+'?pageId=8' ).then(response =>{
              if(response.status == 200){
                  let list = response.body || [];
                  let id = this.$route.params.id;
                  list.map(item =>{
                      if(id == item.id) {
                          
                          item.caseArray && item.caseArray.map((em,index) => {
                              em.labels = (em.label && em.label.split(',').length > 0) ? em.label.split(',')[0] : ''
                              this.$set(item.caseArray, index, em)
                              
                          })
                          this.caseList = item.caseArray || []; 
                      }
                      
                  })
                  console.log(this.caseList)
                  this.$nextTick(()=>{
                      if(this.caseList.length > 0){
                          setTimeout(() => {
                            this.waterFall();    
                          }, 300);
                          
                      }
                  })
              } else {
                  this.$message.error(response.message?response.message:'error');
              }
            }).catch((res)=>{
                this.$message.error('error');
            })
        },
        waterFall() {
            var pic = document.getElementById('caseList');
            var items = pic.children;
            let top = items[0].offsetTop
            let space = items[0].offsetLeft;
            var itemWidth = items[0].offsetWidth;
            var columns = 2;
            var picList = [];
            for (var i = 0; i < items.length; i++) {
                if (i == 0) {
                    items[i].style.top = top + 'px';
                    items[i].style.left = space + 'px';
                    picList.push(items[i].offsetHeight);
                } else if(i==1){
                    items[i].style.top = top + 'px';
                    items[i].style.left = (itemWidth + 2*space) * i + 'px';
                    picList.push(items[i].offsetHeight);
                } else {
                    // 找到数组中最小高度的那一列，并拿到其下标
                    var minHeight = picList[0];
                    var index = 0;
                    for (var j = 0; j < picList.length; j++) {
                        if (minHeight > picList[j]) {
                            minHeight = picList[j];
                            index = j;
                        }
                    }
                    items[i].style.top = top +picList[index] + space + 'px';
                    items[i].style.left = items[index].offsetLeft +  'px';
                    // 操作列的高度 = 当前列原本高度 + 图片的高度 + 相邻的间距
                    picList[index] = picList[index] + items[i].offsetHeight + space;
                }
            }
            this.$nextTick(()=>{
                let totalTop = items[items.length - 1].offsetTop + items[items.length - 1].offsetHeight + space;
                pic.style.height = totalTop + 'px';
            })
        },
        loadImg() {
            this.loadNum++;
            if(this.loadNum == this.caseList.length || this.loadNum%6 == 0) {
                this.$nextTick(()=>{
                    this.waterFall();
                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/base.scss";
.main {
    background: #f5f5f5;
    .caseList {
        min-height: calc(100vh - 1.2307rem);
        padding: poToRem(74) poToRem(20) poToRem(20);
        box-sizing: border-box;
        width: 100vw;
        position: relative;
        &:after{content: "";
                 height: 0;
                 clear: both;
                 overflow: hidden;
                 display: block;
                 visibility: hidden;}
        .item {
            position: absolute;
            width: calc(100%/2 - 0.766rem);
            margin-bottom: poToRem(20);
            background: #ffffff;
            // border-radius: poToRem(12);
            overflow: hidden;
            img {
                width: 100%;
                display: block;
            }
            .info {
                padding: poToRem(12);
                .name {
                    color: #000000;
                    font-size: poToRem(14);
                    text-align: left;   
                    // line-height: poToRem(16);
                    margin-bottom: poToRem(8);
                }
                .clear {
                    color: rgba(51,51,51,0.4);
                    font-size: poToRem(12);
                }
            }
        }
        .empty {
            text-align: center;
            color: #ffffff;
            font-size: poToRem(12);
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/modules/view/case/mobile.vue